import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { TravelExplore as TravelExploreIcon } from '@mui/icons-material';
import {
  estilosBotonInfo360Listado,
  evaluarSemaforoProductoListado,
} from './semaforoProductoListado';
import { prefetchInfo360 } from './info360ProductoCache';

interface ProductoRow {
  codigoArticulo: string;
  cantidad?: number | null;
  stockMin?: number | null;
  tipoArticulo?: string | null;
  coberturaDias?: number | null;
  demandaMensual6m?: number | null;
  leadTimeDias?: number | null;
}

interface Props {
  producto: ProductoRow;
  onClick: () => void;
  size?: 'small' | 'medium';
  /** Listados: 28×28. */
  compact?: boolean;
  /** Grillas densas (POS): alineado a IconButton small vecinos. */
  dense?: boolean;
}

const ProductoInfo360ListButton: React.FC<Props> = ({
  producto,
  onClick,
  size = 'small',
  compact = false,
  dense = false,
}) => {
  const semaforo = evaluarSemaforoProductoListado(producto);
  const tooltip = `Info 360 · ${semaforo.titulo}`;

  const handlePrefetch = () => {
    prefetchInfo360(producto.codigoArticulo);
  };

  return (
    <Tooltip title={tooltip}>
      <IconButton
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
        onMouseEnter={handlePrefetch}
        onFocus={handlePrefetch}
        aria-label={tooltip}
        sx={{
          ...estilosBotonInfo360Listado(semaforo.severidad),
          ...(dense
            ? { p: 0.25 }
            : compact
              ? { p: 0.5 }
              : {}),
        }}
      >
        <TravelExploreIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default ProductoInfo360ListButton;
